import {
  Box,
  // CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import React, { useEffect, /* useRef, */ useState } from "react";
import { PiPlusBold } from "react-icons/pi";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../redux/common/actions";
import Prerequesite from "../courseManagement/preRequesite";
import masterActions from "../../redux/master/actions";
import xlsxpng from "../../assets/images/uploads/xlsx.png";
import { PiXBold } from "react-icons/pi";
import { IoCloudUploadOutline } from "react-icons/io5";

import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import CommonTable from "../../common/CommonTable";
import scorecardActions from "../../redux/scorecard/actions";
import Template from "../../assets/files/score_data_template.xlsx";
// import { io } from "socket.io-client";
// import { API_URL, NODE_ENV } from "../../utils/constants";
// import { cssProperties } from "../../utils/commonCssProperties";
import DataTable from "../../common/dataTable";
import TablePagination from "../../common/tablePagination";
import xlsx from "json-as-xlsx";
let columnData = [
  {
    name: "Exam Date",
    accessor: "examdate",
  },
  {
    name: "Batch No",
    accessor: "batch",
  },
  {
    name: "Paper Name",
    accessor: "papername",
  },
  {
    name: "Candidate Count",
    accessor: "candidatecount",
  },
];

let settings = {
  fileName: "Score Card Generated Data",
  extraLength: 3,
  writeMode: "writeFile",
  writeOptions: {},
  RTL: false,
};

let callback = function (sheet) {
};
export default function Index() {
  const dispatch = useDispatch();
  // let socketRef = useRef(null);
  const [courseId, setCourseId] = useState(null);
  const [open, setOpen] = useState({ open: false, type: null });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [intervalId, setIntervalId] = useState(null);
  const [isExternalData, setIsExternalData] = useState("0");
  const [generateMethod, setGenerateMethod] = useState("");
  const { courseList } = useSelector((state) => state.masterReducer);
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const { scoreCardData, generatedScoreData } = useSelector(
    (state) => state.scorecardReducer
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [itemOffset, setItemOffset] = useState(0);
  const pageCount = Math.ceil(scoreCardData?.length / 100);

  const tableData = scoreCardData;
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
  }, [dispatch]);

  // Socket based live status tracking - disabled. The generate/upload APIs now
  // only report that the job has started; use the Refresh button to pull results.
  // const [statusModalopen, setStatusModalOpen] = useState({
  //   open: false,
  //   statustext: "",
  // });
  // let getDataInterval = (courseid, scorelogid) => {
  //   let intervalId = setInterval(() => {
  //     socketRef?.current?.emit("scoredatastatus", {
  //       courseid,
  //       scorelogid,
  //     });
  //   }, 2000);
  //   return intervalId;
  // };
  // let getScoreGenerateInterval = (courseid, scoregenerateid) => {
  //   let intervalId = setInterval(() => {
  //     socketRef?.current?.emit("scoregeneratestatus", {
  //       courseid,
  //       scoregenerateid,
  //     });
  //   }, 2000);
  //   return intervalId;
  // };
  // useEffect(() => {
  //   socketRef.current = io(
  //     `${API_URL}`,
  //     NODE_ENV === "production" && {
  //       path: "/api/socket.io/",
  //       //     transports: ['websocket', 'polling'],
  //       // reconnection: true,
  //       // reconnectionAttempts: 5,
  //       // reconnectionDelay: 1000
  //     }
  //   );
  //   socketRef?.current?.on("scoredatamessage", (message) => {
  //     // let data = message?.data
  //     if (message?.statusCode === 200) {
  //       let statustext = message?.data?.trim();
  //       if (statustext) {
  //         if (statustext?.toLowerCase() !== "success") {
  //           setStatusModalOpen({
  //             open: true,
  //             statustext:
  //               statustext?.trim() !== "" && statustext !== null
  //                 ? statustext
  //                 : statusModalopen.statustext,
  //           });
  //         } else {
  //           setStatusModalOpen({
  //             open: false,
  //             statustext:
  //               statustext?.toLowerCase() !== "success"
  //                 ? ""
  //                 : statusModalopen.statustext,
  //           });
  //           clearInterval(intervalId);
  //
  //           dispatch({
  //             type: commonActions.SET_ALERT,
  //             payload: {
  //               status: "success",
  //               show: true,
  //               message: "Score Data Uploaded successfully",
  //             },
  //           });
  //
  //           setTimeout(function () {
  //             dispatch({
  //               type: commonActions.SET_ALERT,
  //               payload: {
  //                 status: "success",
  //                 show: false,
  //                 message: null,
  //               },
  //             });
  //           }, 2000);
  //           statustext?.toLowerCase() == "success" &&
  //             dispatch({
  //               type: scorecardActions.GET_SCORE_DATA,
  //               payload: { courseid: courseId, isExternalData: isExternalData },
  //             });
  //         }
  //       }
  //       //  else {
  //       //   setStatusModalOpen({
  //       //     open: false,
  //       //     statustext: "",
  //       //   });
  //       // }
  //     }
  //   });
  //   socketRef?.current?.on("scoregeneratemessage", (message) => {
  //     // let data = message?.data
  //     if (message?.statusCode === 200) {
  //       let statustext = message?.data?.trim();
  //       if (statustext) {
  //         if (statustext?.toLowerCase() !== "success") {
  //           setStatusModalOpen({
  //             open: true,
  //             statustext:
  //               statustext?.trim() !== "" && statustext !== null
  //                 ? statustext
  //                 : statusModalopen.statustext,
  //           });
  //         } else {
  //           setStatusModalOpen({
  //             open: false,
  //             statustext:
  //               statustext?.toLowerCase() !== "success"
  //                 ? ""
  //                 : statusModalopen.statustext,
  //           });
  //           clearInterval(intervalId);
  //
  //           dispatch({
  //             type: commonActions.SET_ALERT,
  //             payload: {
  //               status: "success",
  //               show: true,
  //               message: "Score Generated successfully",
  //             },
  //           });
  //
  //           setTimeout(function () {
  //             dispatch({
  //               type: commonActions.SET_ALERT,
  //               payload: {
  //                 status: "success",
  //                 show: false,
  //                 message: null,
  //               },
  //             });
  //           }, 2000);
  //           statustext?.toLowerCase() == "success" &&
  //             dispatch({
  //               type: scorecardActions.GET_GENERATED_SCORE_DATA,
  //               payload: { courseid: courseId, isExternalData: isExternalData },
  //             });
  //         }
  //       }
  //       //  else {
  //       //   setStatusModalOpen({
  //       //     open: false,
  //       //     statustext: "",
  //       //   });
  //       // }
  //     }
  //   });
  //   return () => (socketRef.current = null);
  // }, [courseId, intervalId, dispatch, socketRef, isExternalData]);

  const handleRefresh = () => {
    if (!courseId) return;
    dispatch({
      type: scorecardActions.GET_SCORE_DATA,
      payload: { courseid: courseId, isExternalData: isExternalData },
    });
    dispatch({
      type: scorecardActions.GET_GENERATED_SCORE_DATA,
      payload: { courseid: courseId, isExternalData: isExternalData },
    });
  };
  const handleCourseChange = (e) => {
    setCourseId(e.target.value);
    dispatch({ type: scorecardActions.SET_GENERATED_SCORE_DATA, payload: [] });
    dispatch({
      type: scorecardActions.SET_SCORE_DATA,
      payload: [],
    });
    dispatch({
      type: scorecardActions.GET_SCORE_DATA,
      payload: { courseid: e.target.value, isExternalData: isExternalData },
    });
    dispatch({
      type: scorecardActions.GET_GENERATED_SCORE_DATA,
      payload: {
        courseid: e.target.value,
        isExternalData: isExternalData,
      },
    });
  };
  const toggleOpen = (type) => {
    setOpen({
      open: !open.open,
      type: type,
    });
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy"; // Show the copy cursor when dragging
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDocumentUpload(e);
  };
  const handleDocumentUpload = (e) => {
    const file = e.target.files[0] || e.dataTransfer.files[0];
    setFile(file);
  };
  const handleUploadCandidateData = () => {
    if (courseId && file) {
      dispatch({
        type: scorecardActions.UPLOAD_CANDIDATE_DATA,
        payload: {
          courseid: courseId,
          id: backofficeTokenDetails?.id,
          isExternalData: isExternalData,
          file,
          setOpen,
          setLoading,
          // getDataInterval: getDataInterval,
          // setIntervalId: setIntervalId,
          // setStatusModalOpen: setStatusModalOpen,
          setFile,
        },
      });
    }
  };
  const handleUploadTemplate = () => {
  };
  const handleDownloadTemplate = async () => {
    try {
      // const fileUrl = '';

      // const res = await fetch(fileUrl);
      // const response = res.clone();
      // const blob = await response.blob();

      //   // Create a blob URL
      //   const blobUrl = window.URL.createObjectURL(  new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      // if (!response.ok) {
      //   throw new Error('File not found. Please make sure the file exists in the assets folder.');
      // }
      const link = document.createElement("a");
      link.href = Template;

      link.setAttribute("download", "score_card_template.xlsx");

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
    }
  };
  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * 100;
    scoreCardData?.length > newOffset && setItemOffset(newOffset);
    setCurrentPage(value);
  };
  const handleGenerate = () => {
    courseId &&
      dispatch({
        type: scorecardActions.GENERATE_SCORE_DATA,
        payload: {
          courseid: courseId,
          isExternalData: isExternalData,
          generateMethod: generateMethod,
          userid: backofficeTokenDetails?.id,
          setOpen,
          setLoading,
          // getScoreGenerateInterval: getScoreGenerateInterval,
          // setIntervalId: setIntervalId,
          // setStatusModalOpen: setStatusModalOpen,
        },
      });
  };

  const handleReset = async () => {
    dispatch({
      type: scorecardActions.RESET_GENERATED_DATA,
      payload: {
        courseid: courseId,
        isExternalData: isExternalData,
      },
    });
    dispatch({ type: scorecardActions.SET_GENERATED_SCORE_DATA, payload: [] });
    // dispatch({
    //   type: scorecardActions.SET_SCORE_DATA,
    //   payload: [],
    // });
  };

  const handleGeneratePdf = async () => {
    courseId &&
      dispatch({
        type: scorecardActions.GENERTAE_SCORECARD_PDF,
        payload: {
          courseid: courseId,
          isExternalData: isExternalData,
          userid: backofficeTokenDetails?.id,
          generateMethod: generateMethod,
        },
      });
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "start", py: 2 }}>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <FormControl>
            <FormLabel id="demo-controlled-radio-buttons-group">
              Is External Data Generation
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={isExternalData}
              onChange={(e) => {
                setIsExternalData(e.target.value);
                if (courseId) {
                  dispatch({
                    type: scorecardActions.SET_GENERATED_SCORE_DATA,
                    payload: [],
                  });
                  dispatch({
                    type: scorecardActions.SET_SCORE_DATA,
                    payload: [],
                  });
                  dispatch({
                    type: scorecardActions.GET_SCORE_DATA,
                    payload: {
                      courseid: courseId,
                      isExternalData: e.target.value,
                    },
                  });
                  dispatch({
                    type: scorecardActions.GET_GENERATED_SCORE_DATA,
                    payload: {
                      courseid: courseId,
                      isExternalData: e.target.value,
                    },
                  });
                }
              }}
              row
            >
              <FormControlLabel value="1" control={<Radio />} label="Yes" />
              <FormControlLabel value="0" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>

          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>
              Select Course
              <span className="error" style={{ color: "red" }}>
                *
              </span>
            </InputLabel>
            <Select
              size="small"
              label="Select Course"
              onChange={handleCourseChange}
              value={courseId ?? ""}
            >
              <MenuItem value="">
                <em>--Select--</em>
              </MenuItem>
              {courseList?.all?.map((course, i) => (
                <MenuItem key={i} value={course.courseid}>
                  {course.coursename}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <MauvelousPrimaryButton
              handleClick={() => {
                if (courseId) {
                  toggleOpen("candidate");
                }
              }}
              disabled={!courseId}
              title=" Upload Candidate Data"
            ></MauvelousPrimaryButton>
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <MauvelousPrimaryButton
              handleClick={() => {
                if (courseId) {
                  toggleOpen("template");
                }
              }}
              disabled={!courseId}
              title=" Upload Template"
            ></MauvelousPrimaryButton>
          </Box> */}
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <MauvelousPrimaryButton
              disabled={!courseId}
              title=" Dowload Template"
              handleClick={handleDownloadTemplate}
            ></MauvelousPrimaryButton>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: "100%", textAlign: "center" }} paddingTop={2}>
        {/* <CommonTable tableData={tableData} columnData={columnData} /> */}

        <Box sx={{ width: "100%", paddingTop: 2 }}>
          <DataTable values={tableData} keys={columnData} page={"score data"} />
        </Box>
        <Box sx={{ padding: "15px 0", width: "100%", py: 1 }}>
          <TablePagination
            pageCount={pageCount}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />
        </Box>
      </Box>

      <Box sx={{ width: "100%", textAlign: "center" }} paddingTop={2}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>
            Generate Method
            <span className="error" style={{ color: "red" }}>
              *
            </span>
          </InputLabel>
          <Select
            size="small"
            label="Generate Method"
            onChange={(e) => setGenerateMethod(e.target.value)}
            value={generateMethod ?? ""}
          >
            <MenuItem value="">
              <em>--Select--</em>
            </MenuItem>

            <MenuItem value={"1"}>Percentile - Single Batch</MenuItem>
            <MenuItem value={"2"}>Percentile - Multi Batch</MenuItem>
            <MenuItem value={"3"}>
              Percentile - Multi subject Multi Batch
            </MenuItem>
          </Select>
        </FormControl>
        <MauvelousPrimaryButton
          disabled={
            generateMethod == "" ||
            !courseId ||
            scoreCardData.length < 1 ||
            generatedScoreData.length > 0
          }
          handleClick={handleGenerate}
          title=" Generate Score Card Data"
        ></MauvelousPrimaryButton>
        <MauvelousPrimaryButton
          disabled={!courseId}
          handleClick={handleRefresh}
          title=" Refresh"
        ></MauvelousPrimaryButton>
        <MauvelousPrimaryButton
          disabled={!courseId || generatedScoreData.length < 1}
          handleClick={handleReset}
          title=" Reset Data"
        ></MauvelousPrimaryButton>
        <MauvelousPrimaryButton
          disabled={!courseId || generatedScoreData.length < 1}
          handleClick={handleGeneratePdf}
          title="Generate PDF"
        ></MauvelousPrimaryButton>
        <MauvelousPrimaryButton
          disabled={!courseId || generatedScoreData.length < 1}
          title=" Download Score Card Data"
          handleClick={() => {
            if (generatedScoreData && generatedScoreData.length === 1) {
              let columns = [
                {
                  label: "SI No",
                  value: "sno",
                },
                {
                  label: "Roll Number",
                  value: "rollno",
                },
                {
                  label: "Exam Date",
                  value: "examdate",
                },
                {
                  label: "Final marks",
                  value: "finalmarks",
                },
                {
                  label: "Batch",
                  value: "batch",
                },
                {
                  label: "Present absent status",
                  value: "pastatus",
                },
                {
                  label: "Paper Name",
                  value: "papername",
                },
                {
                  label: "Percentile",
                  value: "percentile",
                },
              ];

              // for (let i = 0; i < Object.keys(generatedScoreData[0]).length; i++) {
              //   let obj = {};
              //   obj.label = Object.keys(generatedScoreData[0])[i];
              //   obj.value = Object.keys(generatedScoreData[0])[i];
              //   columns.push(obj);
              // }
              let gendata = generatedScoreData[0]?.data?.map((obj, i) => {
                return { ...obj, sno: i + 1 };
              });
              let data = [
                {
                  sheet: generatedScoreData[0]?.papername ? generatedScoreData[0]?.papername : "Sheet 1",
                  columns: columns,
                  content: gendata,
                },
              ];
              xlsx(data, settings, callback);
            } else if (generatedScoreData && generatedScoreData.length > 1) {
              let data = [];
              generatedScoreData.forEach((obj) => {
                let columns = [
                  {
                    label: "SI No",
                    value: "sno",
                  },
                  {
                    label: "Roll Number",
                    value: "rollno",
                  },
                  {
                    label: "Exam Date",
                    value: "examdate",
                  },
                  {
                    label: "Final marks",
                    value: "finalmarks",
                  },
                  {
                    label: "Batch",
                    value: "batch",
                  },
                  {
                    label: "Present absent status",
                    value: "pastatus",
                  },
                  {
                    label: "Percentile",
                    value: "percentile",
                  },
                ];

                // for (let i = 0; i < Object.keys(generatedScoreData[0]).length; i++) {
                //   let obj = {};
                //   obj.label = Object.keys(generatedScoreData[0])[i];
                //   obj.value = Object.keys(generatedScoreData[0])[i];
                //   columns.push(obj);
                // }
                let gendata = obj?.data?.map((param, i) => {
                  return { ...param, sno: i + 1 };
                });
                data.push({
                  sheet: obj?.papername,
                  columns: columns,
                  content: gendata,
                });
              });
              xlsx(data, settings, callback);
            } else {
            }
          }}
        ></MauvelousPrimaryButton>
      </Box>
      <Modal
        open={open.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          {file ? (
            <Box
              pl={2}
              style={{
                width: "fit-content",
                // maxWidth: "18em",
                height: "45px",
                border: "1px solid #D5D5D5",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
                paddingLeft: "0",
                // overflow: "hidden",
                // whiteSpace: "nowrap",
                // position: 'relative'
              }}
            >
              <img
                src={xlsxpng}
                style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                alt="xlsx"
              />
              <Box sx={{ paddingLeft: "10px" }}>{file?.name}</Box>
              <Box
                onClick={() => setFile(null)}
                sx={{ paddingRight: "10px", cursor: "pointer" }}
                //  sx={{position: 'absolute', right: 0, width: '1.5rem', paddingLeft: '5px', backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`}}
              >
                <PiXBold />
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                border: "1px dashed gray",
                maxWidth: "330px",
                minHeight: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 340,
                position: "relative",
              }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <input
                type="file"
                name="document"
                id="document"
                accept=".xlsx"
                alt=""
                style={{
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1,
                }}
                onChange={handleDocumentUpload}
              />

              <label
                htmlFor="document"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IoCloudUploadOutline style={{ marginLeft: "8px" }} size={22} />{" "}
                <span>
                  {" "}
                  &nbsp; Drag or drop your file, or{" "}
                  <span style={{ color: "blue" }}>&nbsp;browse</span>
                </span>
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  (xlsx) (5mb max.)
                </small>
              </label>
            </Box>
          )}
          <Box
            mt={2}
            justifyContent="end"
            alignItems="center"
            display="flex"
            gap={1}
          >
            <BluePrimaryButton
              disabled={loading}
              handleSubmit={() => {
                toggleOpen();
                setFile(null);
              }}
              title="Close"
            />
            <MauvelousPrimaryButton
              disabled={loading || !file || courseId === 0}
              handleClick={
                open.type === "candidate"
                  ? handleUploadCandidateData
                  : handleUploadTemplate
              }
              title="Submit"
            />
          </Box>
        </Box>
      </Modal>
      {/* Processing status modal - driven by the socket, disabled along with it.
      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box my={2}>
            <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>
      */}
    </>
  );
}
